<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">活动模版</h3>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
    <el-tabs v-model="tab" @tab-click="handleClick" type="card">
      <el-tab-pane label="分类列表" name="cate" v-loading="loading">
        <div class="filter-row category-filter-row">
          <el-radio-group v-model="cateStatus" size="default" @change="refreshCateData">
            <el-radio-button v-for="item, index in showOptions" :key="index" :label="item.value">{{ item.name
            }}</el-radio-button>
          </el-radio-group>
          <el-button type="primary" @click="handleCreate">
            <i class="fas fa-plus mr-1"></i>
            新增分类
          </el-button>
        </div>

        <el-table style="margin-top: 16px;" :data="cateData" border>
          <el-table-column prop="label" label="分类名称"></el-table-column>
          <el-table-column prop="sort" label="分类排序"></el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-button @click="editCate(scope.row)" type="text">编辑</el-button>
              <el-button @click="showCate(scope.row)" type="text">{{ cateStatus == 0 ? '上架' : '下架' }}</el-button>
              <el-button @click="deleteCate(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 16px; text-align: right" background
          layout="total, sizes, prev, pager, next, jumper" :total="cateTotal" :page-sizes="[20, 50, 100]"
          @size-change="handleCateSizeChange" @current-change="handleCateCurrentChange" :current-page="currentCatePage"
          :page-size="catePageSize">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="模版列表" name="template" v-loading="loading">
        <div class="filter-row">
          <el-radio-group v-model="templateStatus" size="default" @change="refreshTemplateData">
            <el-radio-button v-for="item, index in showOptions" :key="index" :label="item.value">{{ item.name
            }}</el-radio-button>
          </el-radio-group>
          <el-input
            v-model="templateFilters.search_id"
            placeholder="请输入活动 ID"
            clearable
            style="width: 220px;"
            @keyup.enter="refreshTemplateData"
            @clear="refreshTemplateData"
          ></el-input>
          <el-select
            v-model="templateFilters.cate"
            placeholder="请选择所属分类"
            clearable
            style="width: 220px;"
            @change="refreshTemplateData"
            @clear="refreshTemplateData"
          >
            <el-option v-for="item in cateOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <el-button type="primary" @click="refreshTemplateData">搜索</el-button>
          <el-button @click="resetTemplateFilters">重置</el-button>
          <el-button type="primary" @click="addTemplate">
            <i class="fas fa-plus mr-1"></i>
            新增模版
          </el-button>
        </div>
        <el-table style="margin-top: 16px;" :data="templateData" border>
          <el-table-column prop="source_id" label="活动id"></el-table-column>
          <el-table-column prop="name" label="活动名称"></el-table-column>
          <el-table-column label="分类">
            <template #default="scope">
              {{ formatTemplateLabels(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="目标">
            <template #default="scope">
              {{ formatTemplateGoals(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="模版排序"></el-table-column>
          <el-table-column label="图片">
            <template #default="scope">
              <img style="width: 100px;height: 100px;object-fit: contain;" :src="scope.row.pic" />
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="活动描述"></el-table-column>
          <el-table-column label="引用次数">
            <template #default="scope">
              <div>{{ scope.row.ref_c || 0 }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <el-button @click="editTemplate(scope.row)" type="text">编辑</el-button>
              <el-button @click="showTemplate(scope.row)" type="text">{{ templateStatus == 0 ? '上架' : '下架'
              }}</el-button>
              <el-button @click="deleteTemplate(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 16px; text-align: right" background
          layout="total, sizes, prev, pager, next, jumper" :total="templateTotal" :page-sizes="[20, 50, 100]"
          @size-change="handleTemplateSizeChange" @current-change="handleTemplateCurrentChange"
          :current-page="currentTemplatePage" :page-size="templatePageSize">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="编辑分类" :close-on-click-modal="false" v-model="cateFormVisible" width="460px">
      <el-form ref="cateForm" :model="cateForm" label-width="80px">
        <el-form-item label="分类名称">
          <el-input placeholder="请输入分类名称" v-model="cateForm.label"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="cateForm.sort" :min="0" placeholder="请输入数字"
            controls-position="right"></el-input-number>
          <span style="margin-left: 10px;color: #999">数字越大越靠前</span>
        </el-form-item>
      </el-form>
      <template #footer><div class="dialog-footer">
        <el-button @click="cateFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveCate">确定</el-button>
      </div></template>
    </el-dialog>

    <el-dialog title="编辑模版" :close-on-click-modal="false" v-model="templateFormVisible" width="560px">
      <el-form ref="templateForm" :model="templateForm" label-width="100px">
        <el-form-item label="活动id">
          <el-input placeholder="请输入活动id" v-model="templateForm.source_id"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="templateForm.sort" :min="0" placeholder="请输入数字"
            controls-position="right"></el-input-number>
          <span style="margin-left: 10px;color: #999">数字越大越靠前</span>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="templateForm.cates" multiple placeholder="请选择分类">
            <el-option v-for="item in cateOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标">
          <el-select v-model="templateForm.goal_ids" multiple placeholder="请选择目标">
            <el-option v-for="item in templateGoalOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            name="file"
            class="template-image-uploader"
            drag
            :action="uploadImgUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :data="upload_data"
            :on-success="handleImgSuccess"
            :before-upload="beforeImgUpload"
          >
            <div class="template-upload-content">
              <img v-if="templateForm.pic" :src="templateForm.pic" class="template-upload-preview" />
              <template v-else>
                <i class="fas fa-cloud-upload-alt template-upload-icon"></i>
                <div class="template-upload-text">拖放图片到这里，或点击上传</div>
              </template>
            </div>
            <template #tip><div class="template-upload-tip">奖品图片比例为4:3，大小不超过 5MB</div></template>
          </el-upload>
        </el-form-item>
        <el-form-item label="活动描述">
          <el-input v-model="templateForm.desc" placeholder="请输入活动描述" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <template #footer><div class="dialog-footer">
        <el-button @click="templateFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTemplate">确定</el-button>
      </div></template>
    </el-dialog>

  </div>
</template>

<script>


export default {
  name: 'TemplateList',
  data() {
    return {
      loading: false,
      tab: 'cate', //cate 标签，template，模版
      showOptions: [
        {
          name: '未上架',
          value: 0,
        },
        {
          name: '已上架',
          value: 1
        }
      ],
      uploadImgUrl: this.$uploadImageUrl,
      uploadHeaders: this.$getUploadHeaders(),
      upload_data: { biz: 'console' },

      cateData: [],
      cateTotal: 0,
      currentCatePage: 1,
      catePageSize: 20,
      cateFormVisible: false,
      cateForm: {
        label: '',
        sort: 0,
      },
      cateStatus: 0,


      templateStatus: 0,
      templateGoalOptions: [
        { label: '拉新获客', value: 'new-customer' },
        { label: '门店引流', value: 'store-traffic' },
        { label: '社群促活', value: 'community-active' },
        { label: '公众号涨粉', value: 'official-account-growth' },
        { label: '会员运营', value: 'member-operation' },
        { label: '现场互动', value: 'live-interaction' },
        { label: '节日营销', value: 'festival-marketing' },
      ],
      cateOptions: [],
      templateData: [],
      templateTotal: 0,
      currentTemplatePage: 1,
      templatePageSize: 20,
      templateFilters: {
        search_id: '',
        cate: ''
      },
      templateFormVisible: false,
      templateForm: {
        source_id: '',
        sort: 0,
        cates: [],
        goal_ids: []
      }

    }
  },
  mounted() {
    if (this.tab == 'cate') {
      this.queryCateData()
    } else {
      this.queryTemplateData()
      this.getCateOptions()
    }
  },
  methods: {
    handleImgSuccess(res) {
      if (res.sta == 0) {
        this.templateForm.pic = res.data.url;
      } else {
        this.$message.error(res.msg || '图片上传失败')
      }
    },
    beforeImgUpload(file) {
      const isImage = file.type && file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('请选择图片文件')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isImage && isLt2M;
    },
    handleClick(tab) {
      this.tab = tab.props.name
      if (this.tab == 'cate') {
        this.queryCateData()
      } else {
        this.queryTemplateData()
        this.getCateOptions()
      }
    },
    refreshCateData() {
      this.currentCatePage = 1
      this.queryCateData()
    },
    refreshCurrentTab() {
      if (this.tab == 'cate') {
        this.refreshCateData()
      } else {
        this.refreshTemplateData()
      }
    },
    handleCreate() {
      if (this.tab == 'cate') {
        this.addCate()
      } else {
        this.addTemplate()
      }
    },
    queryCateData() {
      const params = {
        page: this.currentCatePage,
        page_size: this.catePageSize,
        status: this.cateStatus
      }
      this.loading = true
      this.$$getCateList(params, (res) => {
        if (res.sta === 0) {
          this.loading = false;
          this.cateData = res.data.list;
          this.cateTotal = res.data.total;
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      }, () => {
        this.loading = false
        this.$message.error('数据请求失败')
      })

    },
    editCate(item) {
      this.cateForm = item
      this.cateFormVisible = true
    },
    showCate(item) {
      this.$confirm(`确定${item.status == 0 ? '上架' : '下架'}该分类？`, '提示').then(() => {
        this.$$showCate({
          id: item._id
        }, (res) => {
          if (res.sta === 0) {
            this.queryCateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')
        })
      })

    },
    deleteCate(item) {
      this.$confirm(`确定删除该分类？`, '提示').then(() => {
        this.$$deleteCate({
          data: {
            id: item._id
          }
        }, (res) => {
          if (res.sta === 0) {
            this.queryCateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')

        })
      })
    },

    handleCateSizeChange(val) {
      this.catePageSize = val
      // 刷新
      this.queryCateData()
    },
    handleCateCurrentChange(val) {
      this.currentCatePage = val
      // 刷新
      this.queryCateData()
    },
    addCate() {
      this.cateForm = {
        label: '',
        sort: 0,
      }
      this.cateFormVisible = true
    },
    saveCate() {
      if (!this.cateForm.label) {
        return this.$message.error('请输入分类名称')
      }
      if (this.cateForm._id) {
        this.$$updateCate({
          label: this.cateForm.label,
          sort: this.cateForm.sort,
          id: this.cateForm._id
        }, (res) => {
          if (res.sta === 0) {
            this.cateFormVisible = false
            this.queryCateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')
        })
      } else {
        this.$$addCate({
          ...this.cateForm
        }, (res) => {
          if (res.sta === 0) {
            this.cateFormVisible = false
            this.queryCateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')
        })
      }
    },

    getCateOptions() {
      const params = {
        page: 1,
        page_size: 500,
        status: 1
      }
      this.$$getCateList(params, (res) => {
        if (res.sta === 0) {
          this.cateOptions = res.data.list.map(item => {
            return {
              label: item.label,
              value: item._id
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      }, () => {
        this.$message.error('数据请求失败')
      })
    },
    formatTemplateLabels(item) {
      if (!Array.isArray(item.labels) || item.labels.length === 0) {
        return '-'
      }
      return item.labels.join('、')
    },
    formatTemplateGoals(item) {
      const goalIds = this.getTemplateGoalIds(item)
      if (!goalIds.length) {
        return '-'
      }
      return goalIds.map(goalId => {
        const option = this.templateGoalOptions.find(item => item.value === goalId)
        return option ? option.label : goalId
      }).join('、')
    },
    getTemplateCates(item) {
      if (Array.isArray(item.cates)) {
        return [...item.cates]
      }
      if (Array.isArray(item.cate)) {
        return [...item.cate]
      }
      const cate = item.cate_id || item.cate
      return cate ? [cate] : []
    },
    getTemplateGoalIds(item) {
      if (Array.isArray(item.goal_ids)) {
        return [...item.goal_ids]
      }
      if (Array.isArray(item.goals)) {
        return [...item.goals]
      }
      const goal = item.goal_id || item.goal
      return goal ? [goal] : []
    },
    getTemplatePayload() {
      return {
        id: this.templateForm.id,
        source_id: this.templateForm.source_id,
        sort: this.templateForm.sort,
        cates: this.templateForm.cates,
        goal_ids: this.templateForm.goal_ids,
        pic: this.templateForm.pic,
        desc: this.templateForm.desc
      }
    },
    refreshTemplateData() {
      this.currentTemplatePage = 1
      this.queryTemplateData()
    },
    queryTemplateData() {
      const params = {
        page: this.currentTemplatePage,
        page_size: this.templatePageSize,
        status: this.templateStatus
      }
      if (this.templateFilters.search_id) {
        params.search_id = this.templateFilters.search_id
      }
      if (this.templateFilters.cate) {
        params.cate = this.templateFilters.cate
      }
      this.loading = true
      this.$$getTemplateList(params, (res) => {
        if (res.sta === 0) {
          this.loading = false;
          this.templateData = res.data.list;
          this.templateTotal = res.data.total;
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      }, () => {
        this.loading = false
        this.$message.error('数据请求失败')
      })
    },
    resetTemplateFilters() {
      this.templateFilters = {
        search_id: '',
        cate: ''
      }
      this.refreshTemplateData()
    },
    handleTemplateSizeChange(val) {
      this.templatePageSize = val
      this.queryTemplateData()
    },
    handleTemplateCurrentChange(val) {
      this.currentTemplatePage = val
      this.queryTemplateData()
    },
    addTemplate() {
      this.templateForm = {
        source_id: '',
        sort: 0,
        cates: [],
        goal_ids: [],
        pic: '',
        desc: ''
      }
      this.templateFormVisible = true
    },
    saveTemplate() {
      if (!this.templateForm.source_id) {
        return this.$message.error('请输入活动id')
      }
      if (!Array.isArray(this.templateForm.cates) || this.templateForm.cates.length === 0) {
        return this.$message.error('请选择分类')
      }
      if (!Array.isArray(this.templateForm.goal_ids) || this.templateForm.goal_ids.length === 0) {
        return this.$message.error('请选择目标')
      }
      const payload = this.getTemplatePayload()
      if (!this.templateForm.pic) {
        return this.$message.error('请上传活动图片')
      }
      if (!this.templateForm.desc) {
        return this.$message.error('请输入活动描述')
      }
      if (this.templateForm.id) {
        this.$$updateTemplate(payload, (res) => {
          if (res.sta === 0) {
            this.templateFormVisible = false
            this.queryTemplateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')
        })
      } else {
        this.$$addTemplate(payload, (res) => {
          if (res.sta === 0) {
            this.templateFormVisible = false
            this.queryTemplateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')
        })
      }
    },
    editTemplate(item) {
      this.templateForm = {
        id: item._id,
        source_id: item.source_id,
        cates: this.getTemplateCates(item),
        goal_ids: this.getTemplateGoalIds(item),
        sort: item.sort,
        pic: item.pic,
        desc: item.desc
      }
      this.templateFormVisible = true
    },
    showTemplate(item) {
      this.$confirm(`确定${item.status == 0 ? '上架' : '下架'}该活动模板？`, '提示').then(() => {
        this.$$showTemplate({
          id: item._id
        }, (res) => {
          if (res.sta === 0) {
            this.queryTemplateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')
        })
      })
    },
    deleteTemplate(item) {
      this.$confirm(`确定删除该活动模板？`, '提示').then(() => {
        this.$$deleteTemplate({
          data: {
            id: item._id
          }
        }, (res) => {
          if (res.sta === 0) {
            this.queryTemplateData()
          } else {
            this.$message.error(res.msg);
          }
        }, () => {
          this.$message.error('数据请求失败')
        })
      })
    }

  }
}
</script>

<style scoped>
.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  align-items: center;
}

.category-filter-row {
  justify-content: space-between;
}

.template-image-uploader {
  width: 260px;
}

.template-image-uploader :deep(.el-upload) {
  width: 100%;
}

.template-image-uploader :deep(.el-upload-dragger) {
  width: 260px;
  height: 180px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.template-upload-content {
  width: 100%;
  height: 100%;
  min-height: 178px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.template-upload-preview {
  max-width: 100%;
  max-height: 176px;
  object-fit: contain;
}

.template-upload-icon {
  font-size: 32px;
  color: #a8071a;
  margin-bottom: 10px;
}

.template-upload-text {
  font-size: 14px;
}

.template-upload-tip {
  color: #6b7280;
  font-size: 12px;
  margin-top: 6px;
}
</style>
